import { render, staticRenderFns } from "./social-icons.vue?vue&type=template&id=eb0a46de"
import script from "./social-icons.js?vue&type=script&lang=js&external"
export * from "./social-icons.js?vue&type=script&lang=js&external"
import style0 from "./social-icons.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports